import { _dateFormat } from "./dateformat";

/**
 * 整理登入與登出紀錄
 * @param {Array} loginData - 登入紀錄
 * @param {Array} logoutData - 登出紀錄
 * @param {Function} t - i18n 的 $t 方法
 * @param {String}  namespace - 來自父層 i18n 的命名
 * @returns {Array} - 整理後的 session 紀錄
 */

export function getSessionHistory(loginData = [], logoutData = [], t = (key) => key, namespace) {
    return loginData.map((loginRecord) => {
        const logoutRecord = loginRecord.sessionId ? findCorrespondingLogout(logoutData, loginRecord) : null;

        const { logoutDate, logoutType, sessionDuration } = logoutRecord
            ? buildSessionInfo(loginRecord, t, namespace, logoutRecord) // 有對應登出紀錄
            : buildSessionInfo(loginRecord, t, namespace); // 沒有登出紀錄（自動登出 / 尚未登出）

        return {
            isCurrent: loginRecord.isCurrent,
            sessionId: loginRecord.sessionId,
            loginDate: formatDateTimeLocal(loginRecord.date),
            loginDateRaw: loginRecord.date, // 保留原始 ISO
            loginDevice: loginRecord.device,
            loginIp: loginRecord.ip,
            loginUserAgent: loginRecord["user-agent"],
            logoutDate: logoutDate && logoutDate !== "-" ? formatDateTimeLocal(logoutDate) : logoutDate,
            logoutType,
            sessionDuration,
        };
    });
}

// 找到對應的登出紀錄
function findCorrespondingLogout(logoutData, loginRecord) {
    return logoutData.find((logout) => logout.sessionId === loginRecord.sessionId);
}

function buildSessionInfo(loginRecord, t, namespace, logoutRecord) {
    const loginDate = new Date(loginRecord.date);

    // 預設：沒有登出紀錄（自動登出 / 尚未登出）
    let logoutDate = "";
    let durationMs = Date.now() - loginDate.getTime();
    let logoutType = t(`${namespace}.notLoggedOut`);

    // 有對應登出紀錄
    if (logoutRecord) {
        const logoutDateTime = new Date(logoutRecord.date);
        durationMs = Math.min(Math.max(logoutDateTime - loginDate, 0), 24 * 3600 * 1000);
        logoutDate = logoutDateTime.toISOString();
        logoutType =
            durationMs > 24 * 3600 * 1000
                ? t(`${namespace}.systemLogout`)
                : t(`${namespace}.${logoutRecord.logoutType}`);
    }

    return {
        logoutDate,
        logoutType,
        sessionDuration: formatSessionDuration(durationMs, t),
    };
}

// 將 UTC ISO 時間轉為使用者本地時間
function formatDateTimeLocal(isoString) {
    if (!isoString) return "";
    const date = new Date(isoString);
    return _dateFormat(date, "YYYY-MM-DD HH:mm:ss");
}

// 計算毫秒差並格式化成 "X 小時 Y 分鐘 Z 秒"
function formatSessionDuration(ms, t) {
    if (ms == null) return null;
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours} ${t("global.hour")} ${minutes} ${t("global.min")} ${seconds} ${t("global.second")}`;
}



// WEBPACK FOOTER //
// ./src/libs/sessionHistory.js